<template>
    <div class="home_page" :style="{ paddingTop: dataSet.isShowingPWA ? '100px' : '50px' }">
        <div v-for="(item, index) in dataSet.componentList" :key="index">
            <MainHeader @intallPWA="installApp" @isClosedPWA="isClosedPWA" :listGameData="dataSet.groupList"
                @showPWA="setShowPWA" v-if="isComponentVisible(item, 'header')" @goToProfile="openProfilePopup"
                :itemData="item" @goToGamePanel="goToGamePannel" @openSidebar="openSidebar" />
            <CarousalCard v-if="isComponentVisible(item, 'banners')" :itemData="item" />
            <BannerCard v-if="isComponentVisible(item, 'notice')" :itemData="item" />
            <NoticeBar v-if="isComponentVisible(item, 'newsBar')" :itemData="item" @goToGameSearch="goToGameSearch" />
            <div v-if="isComponentVisible(item, 'gameGroups')">
                <GroupList :ref="el => setGroupListRef(el)" :listData="dataSet.groupList"
                    @goToGamePanel="goToGamePannel" :itemData="item" />
                <div class="home_game_panel" v-for="(subitem, index) in dataSet.groupList" :key="index">
                    <GamePanel :groupImage="subitem.customIcon" :groupName="subitem.showName" :gameList="subitem.games"
                        :itemData="item" @goGamePannel="goToGamePannel(subitem)" />
                </div>
            </div>

            <DownloadPanel v-if="isComponentVisible(item, 'AppDownload')" :itemData="item" />
            <MediaSection v-if="isComponentVisible(item, 'shareMedia')" :itemData="item" />
            <FooterText v-if="isComponentVisible(item, 'footerText')" :itemData="item" />
            <MainFooter v-if="isComponentVisible(item, 'footer')" @goToProfile="openProfilePopup" :itemData="item"
                @profileClose="closeProfilePoup" :ref="setFooterRef" @openPWA="openPWAPopup" />
            <ContactService v-if="isComponentVisible(item, 'contactService')" />
        </div>
    </div>

    <FloatButton @openAgentPopup="goToAgent" @openPWA="openPWAPopup"
        @handleShowTreasurePopup="handleShowTreasurePopup" />
    <!-- Popup -->
    <SideNavbar ref="sideNavbarRef" :listGameData="dataSet.groupList" @intallPWA="installApp"
        @goToGamePanelSlide="goToGamePannel" />
    <GamePopup ref="gamePopupRef" @resetSelectedGroup="resetSelectedGroup" @goToProfile="openProfilePopup" />
    <ProfilePopup ref="profilePopupRef" @openAgentPopup="goToAgent" />
    <PromotionPopup ref="promotionRef" @openAgentPopup="goToAgent" @openPWA="openPWAPopup" />
    <PwaAntiBlockingPopup ref="pwaPopupRef" />
    <PwaStatusPopup ref="pwaPopupStatusRef" />
    <ClaimListPopup
        v-if="userStore.allActivityBonusPopup && userStore.claimActivityList.length > 0 && !userStore.pwaShowing && userStore.isInHome"
        ref="claimListPopupRef" @handleShowTreasurePopup="handleShowTreasurePopup"
        @resetShowTreasurePopup="resetShowTreasurePopup" />

</template>

<script setup lang="ts">
import { ref } from 'vue'
import BannerCard from './components/bannerCard.vue'
import CarousalCard from './components/carousalCard.vue'
import NoticeBar from './components/noticeBar.vue'
import GroupList from './components/groupList.vue'
import GamePanel from './components/gamePanel.vue'
import ContactService from './components/contactService.vue'
import FooterText from './components/footerText.vue'
import DownloadPanel from './components/downloadPanel.vue'
import MediaSection from './components/mediaSection.vue'
import PromotionPopup from '@/view/promotion/promotionPopup.vue'
import FloatButton from './components/floatButton.vue'
import { HomeData } from '@/view/home/supportScript'
import MainHeader from '../components/common/mainHeader.vue'
import MainFooter from '../components/common/mainFooter.vue'
import GamePopup from '@/view/game/gamePopup.vue'
import ProfilePopup from '@/view/profile/profilePopup.vue'
import PwaAntiBlockingPopup from '../components/common/pwaAntiBlockingPopup.vue'
import PwaStatusPopup from '../components/common/pwaStatusPopup.vue'
import SideNavbar from '../components/sideNav/sideNavbar.vue'
import { playClickSound } from '@/utils/media'
import ClaimListPopup from '../components/common/claimListPopup.vue'
import { useUserStore } from '@/stores/user'
import { useRouter } from 'vue-router'
const userStore = useUserStore()
const router = useRouter()
const gamePopupRef = ref()
const profilePopupRef = ref()
const promotionRef = ref();
const pwaPopupRef = ref()
const pwaPopupStatusRef = ref()
const sideNavbarRef = ref()
const claimListPopupRef = ref()
const props = defineProps<{
    dataSet: HomeData
}>()

const emits = defineEmits(['setFooterRef', 'goToGamePannel', 'openProfilePopup', 'isComponentVisible', 'installApp', 'isClosedPWA', 'setShowPWA', 'openPWAPopup', 'setGroupListRef', 'resetSelectedGroup', 'goToAgent', 'handleShowTreasurePopup', 'resetShowTreasurePopup', 'goToGameSearch'])

const setFooterRef = (el: any) => {
    emits('setFooterRef', el)
};
const goToGamePannel = (data: any) => {
    sideNavbarRef.value.closeSidebar()
    if (data.name == 'games.favorite') {
        router.push({
            path: '/searchGames',
            query: { tab: '4' }
        })
    } else if (data.name == 'Hot') {
        router.push({
            path: '/searchGames',
            query: { tab: '2' }
        })
    } else {
        emits('goToGamePannel', data)
    }

}

const openProfilePopup = () => {
    emits('openProfilePopup')
}

const closeProfilePoup = () => {
    profilePopupRef.value.close()
}
const goToAgent = () => {
    emits('goToAgent')
}
const goToGameSearch = () => {
    emits('goToGameSearch')
}
const openSidebar = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') { return false; }
    playClickSound()
    sideNavbarRef.value.openSidebar()
}
const isComponentVisible = (item: any, menuId: string) => {
    return (
        item.component_id === props.dataSet.componentIdsInOrderConfig[menuId] && item.display
    );
};

const installApp = async () => {
    emits('installApp')
}
const isClosedPWA = async (value: any) => {
    emits('isClosedPWA', value)
}
const setShowPWA = async (value: any) => {
    emits('setShowPWA', value)
}

const openPWAPopup = () => {
    emits('openPWAPopup')
}

const setGroupListRef = (el: any) => {
    emits('setGroupListRef', el)
}
const resetSelectedGroup = () => {
    emits('resetSelectedGroup')
}

const gamePoupOpen = (data: any) => {
    gamePopupRef.value.open(data);
}

const profilePoupOpen = (list: any) => {
    profilePopupRef.value.open(list);
}

const pwaPoupOpen = () => {
    pwaPopupRef.value.open()
}

const pwaStatusPoupOpen = (title: string) => {
    pwaPopupStatusRef.value.open(title);
}
const handleShowTreasurePopup = (path: any) => {
    emits('handleShowTreasurePopup', path)
}

const resetShowTreasurePopup = () => {
    emits('resetShowTreasurePopup')
}
defineExpose({
    gamePoupOpen,
    profilePoupOpen,
    pwaStatusPoupOpen,
    pwaPoupOpen
})
</script>
<style scoped>
.home_page {
    /* flex: 1;
    position: relative; */
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0 20px 0;
    /* overflow-y: auto; */
}

.home_page::-webkit-scrollbar {
    display: none;
}
</style>